<template>
  <div class="slide-show" @click="$emit('change-slide')">
    <img src="/assets/images/market/devicewithshadow.svg" class="phone-image" />
    <div class="absolute-box">
      <transition
        :duration="200"
        @before-enter="beforeEnter"
        @after-enter="afterEnter"
        @before-leave="afterEnter"
        @after-leave="beforeEnter"
      >
        <template v-for="(image, index) in allImages">
          <img
            v-if="index === current"
            :key="`slide-image-${index}`"
            :src="image"
            alt="slide-image"
            class="slide-image"
          />
        </template>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SlideShow',
  props: {
    current: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    allImages() {
      return [
        '/assets/images/market/Slide-01.webp',
        '/assets/images/market/Slide-03.webp',
        '/assets/images/market/Slide-02.webp',
      ];
    },
    image() {
      return this.allImages[this.current];
    },
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = '0';
    },
    afterEnter(el) {
      el.style.opacity = '1';
    },
  },
};
</script>

<style scoped>
.slide-show {
  max-width: 400px;
  position: relative;
}

.phone-image {
  width: 100%;
}

.absolute-box {
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.slide-image {
  opacity: 1;
  padding-right: 20px;
  padding-top: 10px;
  transition: opacity 400ms ease-in-out;
  width: 100%;
}
</style>
